import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import SiteLayout from "@/components/layout/SiteLayout";
import LocaleLayout from "@/i18n/LocaleLayout";
import { ROUTES } from "@/constants/routes";

/* Route-level code splitting keeps the first paint to the home bundle. */
const HomePage = lazy(() => import("@/features/home/HomePage"));
const SourceToPayPage = lazy(() => import("@/features/source-to-pay/SourceToPayPage"));
const SolutionsPage = lazy(() => import("@/features/solutions/SolutionsPage"));
const PlatformPage = lazy(() => import("@/features/platform/PlatformPage"));
const AboutPage = lazy(() => import("@/features/about/AboutPage"));
const ContactPage = lazy(() => import("@/features/contact/ContactPage"));
const NotFoundPage = lazy(() => import("@/features/not-found/NotFoundPage"));

function RouteFallback() {
  return <div style={{ minHeight: "60vh" }} aria-busy="true" />;
}

function PageRoutes() {
  return (
    <>
      <Route index element={<HomePage />} />
      <Route path={ROUTES.sourceToPay.slice(1)} element={<SourceToPayPage />} />
      <Route path={ROUTES.solutions.slice(1)} element={<SolutionsPage />} />
      <Route path={ROUTES.platform.slice(1)} element={<PlatformPage />} />
      <Route path={ROUTES.about.slice(1)} element={<AboutPage />} />
      <Route path={ROUTES.contact.slice(1)} element={<ContactPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </>
  );
}

export function AppRoutes() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route element={<LocaleLayout />}>
          <Route element={<SiteLayout />}>{PageRoutes()}</Route>
        </Route>
        <Route path="de" element={<LocaleLayout />}>
          <Route element={<SiteLayout />}>{PageRoutes()}</Route>
        </Route>
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
